import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "lodash";
import { PrivateApi } from "../../../shared/utils/KyApi";
import {
  CreatePersonalApiKeyRequest,
  CreateProductionApiKeyRequest,
  CreateDevelopmentApiKeyRequest,
  RegenerateDevelopmentApiKeyRequest,
  RegenerateDevelopmentApiKeyResponse,
  GetDevelopmentApiKeyRequest,
  GetDevelopmentApiKeyResponse,
} from "../../../types/apiKey";

export const createPersonalApiKey = createAsyncThunk<
  void,
  CreatePersonalApiKeyRequest
>("/api/xdp/v1/apps/personal", async (payload, { rejectWithValue }) => {
  try {
    await PrivateApi()
      .post("api/xdp/v1/apps/personal", {
        json: payload,
      })
      .json()
      .catch((error) => {
        throw error.response;
      });
    return undefined;
  } catch (error) {
    const errorCode = get(error, "status", "");
    const resultError = await (error as Response).json();
    return rejectWithValue({
      message: resultError.message,
      code: errorCode,
    });
  }
});

export const createProductionApiKey = createAsyncThunk<
  void,
  CreateProductionApiKeyRequest
>("/api/xdp/v1/apps/production", async (payload, { rejectWithValue }) => {
  try {
    await PrivateApi()
      .post("api/xdp/v1/apps/production", {
        json: payload,
      })
      .json()
      .catch((error) => {
        throw error.response;
      });
    return undefined;
  } catch (error) {
    const errorCode = get(error, "status", "");
    const resultError = await (error as Response).json();
    return rejectWithValue({
      message: resultError.message,
      code: errorCode,
    });
  }
});

export const createDevelopmentApiKey = createAsyncThunk<
  void,
  CreateDevelopmentApiKeyRequest
>("/api/xdp/v1/user/development", async (payload, { rejectWithValue }) => {
  try {
    await PrivateApi()
      .post("api/xdp/v1/user/development", {
        json: payload,
      })
      .json()
      .catch((error) => {
        throw error.response;
      });
    return undefined;
  } catch (error) {
    const errorCode = get(error, "status", "");
    const resultError = await (error as Response).json();
    return rejectWithValue({
      message: resultError.message,
      code: errorCode,
    });
  }
});

export const regenerateDevelopmentApiKey = createAsyncThunk<
  RegenerateDevelopmentApiKeyResponse,
  RegenerateDevelopmentApiKeyRequest
>(
  "/api/xdp/v1/user/development/regenerate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PrivateApi()
        .post("api/xdp/v1/user/development/regenerate", {
          json: payload,
        })
        .json<RegenerateDevelopmentApiKeyResponse>()
        .catch((error) => {
          throw error.response;
        });
      return response;
    } catch (error) {
      const errorCode = get(error, "status", "");
      const resultError = await (error as Response).json();
      return rejectWithValue({
        message: resultError.message,
        code: errorCode,
      });
    }
  }
);

export const getDevelopmentApiKey = createAsyncThunk<
  GetDevelopmentApiKeyResponse,
  GetDevelopmentApiKeyRequest
>("/api/xdp/v1/user/development/get", async (payload, { rejectWithValue }) => {
  try {
    const response = await PrivateApi()
      .get("api/xdp/v1/user/development")
      .json<GetDevelopmentApiKeyResponse>()
      .catch((error) => {
        throw error.response;
      });
    return response;
  } catch (error) {
    const errorCode = get(error, "status", "");
    const resultError = await (error as Response).json();
    return rejectWithValue({
      message: resultError.message,
      code: errorCode,
    });
  }
});
